import { NavLink, useNavigate } from "react-router-dom";

export default function SidebarNavigation({ setAuth }) {
    const navigate = useNavigate();

    const Logout = () => {
        setAuth(false);
        navigate("/");
        sessionStorage.clear();
    };

    const activeStyle = {
        background: "#0000003d",
        border: "1px solid"
    };

    return (
        <div className="sidebarnavi themebg-1 pt-5">
            <ul className="list-group rounded-0 mt-2" id="sidebarAccordion">

                {/* MASTER SECTION */}
                <li className="list-group-item p-0 rounded bg-transparent text-white border-0">
                    <NavLink className="nav-link p-3 d-flex align-items-center" data-bs-toggle="collapse" to="#collapsemaster">
                        <i className="fa-solid fa-user-gear"></i>
                        <strong className="ms-2">MASTER</strong>
                        <span className="ms-2">&#8595;</span>
                    </NavLink>
                    <div className="collapse ms-3" id="collapsemaster" data-bs-parent="#sidebarAccordion">
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/servicemanagement" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">SERVICE MANAGEMENT</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/procmanagement" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">PROCESSOR MANAGEMENT</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/addReseller" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">RESELLER MANAGEMENT</strong>
                        </NavLink>
                    </div>
                </li>

                {/* MERCHANT SECTION */}
                <li className="list-group-item p-0 rounded bg-transparent text-white border-0">
                    <NavLink className="nav-link p-3 d-flex align-items-center" data-bs-toggle="collapse" to="#collapseMeMgmt">
                        <i className="fa-solid fa-user-gear"></i>
                        <strong className="ms-2">MERCHANT MANAGEMENT</strong>
                        <span className="ms-2">&#8595;</span>
                    </NavLink>
                    <div className="collapse ms-3" id="collapseMeMgmt" data-bs-parent="#sidebarAccordion">
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/pendingmerchantmanagement" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">PENDING</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/approvedmerchantmanagement" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">APPROVED</strong>
                        </NavLink>
                    </div>
                </li>

                {/* PAYIN SECTION */}
                <li className="list-group-item p-0 rounded bg-transparent text-white border-0">
                    <NavLink className="nav-link p-3 d-flex align-items-center" data-bs-toggle="collapse" to="#collapsePayin">
                        <i className="fa-solid fa-circle-dollar-to-slot"></i>
                        <strong className="ms-2">PAYIN SECTION</strong>
                        <span className="ms-2">&#8595;</span>
                    </NavLink>
                    <div className="collapse ms-3" id="collapsePayin" data-bs-parent="#sidebarAccordion">
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="dashboard" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">DASHBOARD</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="payinWallet" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">WALLET</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="payinWalletReport" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">WALLET REPORT</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="transactions" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">TRANSACTIONS</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="ptpreport" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">PTP-DEVICE</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="ptpmanualupdate" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">PTP-MANUAL</strong>
                        </NavLink>
                    </div>
                </li>

                {/* PAYOUT SECTION */}
                <li className="list-group-item p-0 rounded bg-transparent text-white border-0">
                    <NavLink className="nav-link p-3 d-flex align-items-center" data-bs-toggle="collapse" to="#collapsePayout">
                        <i className="fa-solid fa-money-bill-transfer"></i>
                        <strong className="ms-2">PAYOUT SECTION</strong>
                        <span className="ms-2">&#8595;</span>
                    </NavLink>
                    <div className="collapse ms-3" id="collapsePayout" data-bs-parent="#sidebarAccordion">
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="payoutDashboard" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">DASHBOARD</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="payoutWallet" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">WALLET</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="reversal" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">REVERSAL</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="passbook" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">PASSBOOK</strong>
                        </NavLink>
                    </div>
                </li>
            </ul>

            {/* LOGOUT BUTTON */}
            <li className="list-group-item p-0 rounded bg-transparent text-white border-0 logout-btn">
                <button className="nav-link p-3 d-flex align-items-center" onClick={Logout}>
                    <i className="fa-solid fa-power-off"></i>
                    <strong className="ms-2">LOGOUT</strong>
                </button>
            </li>
        </div>
    );
}



/* <li className="list-group-item p-0 rounded bg-transparent text-white border-0">
                    <NavLink className="nav-link p-3 d-flex align-items-center" data-bs-toggle="collapse" to="#collapseBeneficiary">
                        <i className="fa-solid fa-hand-holding-dollar"></i>
                        <strong className="ms-2">BENEFICIARY</strong>
                        <span className="ms-2">&#8595;</span>
                    </NavLink>
                    <div className="collapse ms-3" id="collapseBeneficiary">
                        <NavLink className="nav-link p-2 rounded" to="/beneficiary" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">PENDING</strong>
                        </NavLink>
                        <NavLink className="nav-link p-2 rounded" to="/approvedbeneficiary" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">APPROVED</strong>
                        </NavLink>
                    </div>
                </li> */